import { styled, StyleProps } from "../../styles"
import { flexCss } from "../../Flex"

export const FieldContainer = styled.div({
  ...flexCss,
  width: `100%`,
  position: `relative`,
})

export const InputError = styled.span((props: StyleProps) => ({
  display: `block`,
  color: props.theme.palette.error,
  marginTop: props.theme.spacing(2),
}))
